import React from 'react';
import { Route } from 'react-router-dom';
import CrossAnalytics from 'CrossAnalytics';
import Editor from 'Editor';
import Olap from './olap';
import Dashboard from './dashboard';
import Editors from './editors';
import Multiedit from './multiedit';
import Bildfahrplan from './bildfahrplan';


const ModuleRoutes = ({ ...props }) => (
    <div>
        <Route path="/module.olap" render={() => <Olap {...props} />} />
        <Route path="/module.multiedit" render={() => <Multiedit {...props} />} />
        <Route path="/module.editors" render={() => <Editors {...props} />} />
        <Route path="/module.bildfahrplan" render={() => <Bildfahrplan {...props} />} />
        <Route path="/module.dashboard" render={() => <Dashboard {...props} />} />
        <Route path="/module.crossanalytics" render={() => <CrossAnalytics {...props} />} />
        <Route path="/module.editor" render={() => <Editor {...props} />} />
    </div>
);
ModuleRoutes.NewModules = 'bbb';
export default ModuleRoutes;



// WEBPACK FOOTER //
// ./src/modules/index.js